<template>
  <div>
    <button
      v-for="searchTab in searchTabs"
      :key="searchTab.name"
      :class="[
        'icons-facet-tab link flat text-center padding-x-xl padding-top-xl padding-bottom-lg',
        { active: isSelected(searchTab.name) }
      ]"
      style="flex-grow: 1"
      @click.prevent="applyFilter(searchTab.name, searchTab.filters)"
    >
      <i :class="`${searchTab.icon} fa-fw fa-2x`" />
      <span class="display-block margin-top-md size-sm">{{ searchTab.label }}</span>
    </button>

  </div>
</template>
<script>
  import search_tabs from '../search-tabs.json'
  import search_tabs_v5 from '../search-tabs-v5.json'

  export default {
    name: 'SearchTabs',

    props: {
      version: {
        type: Number,
        required: true
      },
      selected: {
        type: String
      }
    },

    data() {
      return {
        selectedTab: ''
      }
    },

    computed: {
      searchTabs() {
        return this.version === 5 ? search_tabs_v5 : search_tabs
      }
    },

    created() {
      this.selectedTab = this.selected
    },

    methods: {
      applyFilter(name, filter) {
        this.selectedTab = name
        this.$emit('applyFilter', filter)
      },

      isSelected(name) {
        return this.selectedTab === name
      }
    }
  }
</script>
